import React from 'react';
import styled from 'styled-components';

import { extractDataForExport } from '../utils';
import messages from './messages';

import { FormattedMessage, useIntl } from 'react-intl';
import { CSVLink } from 'react-csv';
import { isNil } from 'lodash';

const FooterContainer = styled.div`
    padding: 5px;
    text-align: left;

    a {
        font-size: 12px;
        color: inherit;
    }
`;

const convertStatus = (status) => {
    if (isNil(status)) {
        return '';
    }
    switch (status) {
        case 2:
            return 'Guaranteed';
        case 1:
        case 4:
            return 'Cancelled';
        default:
            return 'Non-Guaranteed';
    }
};

const CSVExportFooter = ({ blocks, currency }) => {
    const intl = useIntl();
    const exportData = extractDataForExport(blocks);
    const formatDate = (value) =>
        value &&
        intl.formatDate(value, {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
        });
    const formatRoom = intl.formatNumber;
    const formatRevenue = (value) =>
        intl.formatNumber(value / 100, {
            style: 'currency',
            currency,
        });

    const headers = [
        { label: intl.formatMessage(messages.csvHeaderCode), key: 'code' },
        { label: intl.formatMessage(messages.csvHeaderName), key: 'name' },
        { label: intl.formatMessage(messages.csvHeaderStatus), key: 'status' },
        {
            label: intl.formatMessage(messages.csvHeaderStartDate),
            key: 'startDate',
        },
        {
            label: intl.formatMessage(messages.csvHeaderEndDate),
            key: 'endDate',
        },
        {
            label: intl.formatMessage(messages.csvHeaderSegment),
            key: 'marketCode',
        },
        {
            label: intl.formatMessage(messages.csvHeaderStayDate),
            key: 'stayDate',
        },
        {
            label: intl.formatMessage(messages.csvHeaderBlockedRoomCount),
            key: 'blockedRoomCount',
        },
        {
            label: intl.formatMessage(messages.csvHeaderPickedUpRoomCount),
            key: 'roomsSold',
        },
        {
            label: intl.formatMessage(messages.csvHeaderAvailableRoomCount),
            key: 'availableRoomCount',
        },
        {
            label: intl.formatMessage(messages.csvHeaderRevenueSold),
            key: 'revenueSold',
        },
        {
            label: intl.formatMessage(messages.csvHeaderEstimatedRevenueTotal),
            key: 'estimatedRevenueTotal',
        },
    ];
    const data = exportData.map((row) => ({
        ...row,
        status: convertStatus(row.status),
        startDate: formatDate(row.startDate),
        endDate: formatDate(row.endDate),
        stayDate: formatDate(row.stayDate),
        blockedRoomCount: formatRoom(row.blockedRoomCount),
        pickedUpRoomCount: formatRoom(row.pickedUpRoomCount),
        availableRoomCount: formatRoom(row.availableRoomCount),
        roomsSold: formatRoom(row.roomsSold),
        revenueSold: formatRevenue(row.revenueSold),
        estimatedRevenueTotal: formatRevenue(row.estimatedRevenueTotal),
    }));
    const filename = `${intl.formatMessage(messages.exportedFileName)}.csv`;

    return (
        <FooterContainer>
            <CSVLink headers={headers} data={data} filename={filename}>
                <FormattedMessage {...messages.exportLink} />
            </CSVLink>
        </FooterContainer>
    );
};

export default CSVExportFooter;
